(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("rxjs"), require("rxjs/testing"));
	else if(typeof define === 'function' && define.amd)
		define("JestMarbles", ["rxjs", "rxjs/testing"], factory);
	else if(typeof exports === 'object')
		exports["JestMarbles"] = factory(require("rxjs"), require("rxjs/testing"));
	else
		root["JestMarbles"] = factory(root["rxjs"], root["rxjs/testing"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE_rxjs__, __WEBPACK_EXTERNAL_MODULE_rxjs_testing__) => {
return 